import {
    CREATE_BILL_OF_SALE,
    GET_BILL_OF_SALE_URL,
    SET_ASSET_ORDER_DETAIL_ATTACHMENTS,
    SET_ASSET_ORDER_DETAIL_LINKED_ATTACHMENTS,
    SET_BILL_OF_SALE_URL,
    SET_IS_BILL_OF_SALE_CREATED,
    UPLOAD_ASSET_ORDER_DETAIL_ATTACHMENTS
} from "./BillOfSaleType"

const uploadAssetOrderDetailAttachments = (payload: any) => ({
    type: UPLOAD_ASSET_ORDER_DETAIL_ATTACHMENTS,
    payload
});

const setAssetOrderDetailAttachments = (list: any) => ({
    type: SET_ASSET_ORDER_DETAIL_ATTACHMENTS,
    list
});

const setAssetOrderDetailLinkedAttachments = (linkedList: any) => ({
    type: SET_ASSET_ORDER_DETAIL_LINKED_ATTACHMENTS,
    linkedList
});

const createBillOfSale = (payload: any) => ({
    type: CREATE_BILL_OF_SALE,
    payload
});

const getBillOfSaleUrl = (payload: any) => ({
    type: GET_BILL_OF_SALE_URL,
    payload
});

const setBillOfSaleUrl = (url: any) => ({
    type: SET_BILL_OF_SALE_URL,    
    url   
});

const setIsBillOfSaleCreated = (isBillOfSaleCreated: boolean) => ({
    type: SET_IS_BILL_OF_SALE_CREATED,
    isBillOfSaleCreated
});

export {
    uploadAssetOrderDetailAttachments,
    setAssetOrderDetailAttachments,
    setAssetOrderDetailLinkedAttachments,
    createBillOfSale,
    getBillOfSaleUrl,
    setBillOfSaleUrl,
    setIsBillOfSaleCreated
}
